var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.747 1.358a.282.282 0 0 1 .505 0l1.337 2.71c.04.082.12.14.212.153l2.99.435a.282.282 0 0 1 .155.48L8.784 7.245a.28.28 0 0 0-.08.249l.51 2.977a.282.282 0 0 1-.409.297L6.13 9.362a.28.28 0 0 0-.262 0l-2.674 1.406a.282.282 0 0 1-.408-.297l.51-2.977a.28.28 0 0 0-.08-.25L1.051 5.137a.282.282 0 0 1 .156-.48l2.99-.435a.28.28 0 0 0 .212-.154z"
})));
export default SvgStarFill;